import { render, staticRenderFns } from "./SubBrands.vue?vue&type=template&id=62e28221"
import script from "./SubBrands.vue?vue&type=script&lang=js"
export * from "./SubBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports